const ComplementoPagosDRRules = (data) => {
  const tipoCambioRule = data.MonedaDR !== 'MXN' ? 'required' : 'string';

  let TrasladoRule = data.ObjetoImpDR !== '01'
    ? ['required_without:ImpuestosDR.RetencionesDR.RetencionDR', 'array']
    : [];

  let RetencionRule = data.ObjetoImpDR !== '01'
    ? ['required_without:ImpuestosDR.TrasladosDR.TrasladoDR', 'array']
    : [];

  return {
    'ImpuestosDR.TrasladosDR.TrasladoDR': TrasladoRule,
    'ImpuestosDR.RetencionesDR.RetencionDR': RetencionRule,
    IdDocumento: [
      'required',
      'string',
      'min:16',
      'max:36',
      'regex:/^([a-f0-9A-F]{8}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{12})|([0-9]{3}-[0-9]{2}-[0-9]{9})$/',
    ],
    Serie: [
        'string',
        'min:1',
        'max:25',
        'regex:/^[^|]{1,25}$/',
    ],
    Folio: [
        'string',
        'min:1',
        'max:40',
        'regex:/^[^|]{1,40}$/',
    ],
    MonedaDR: [
      'required',
      'string'
    ],
    EquivalenciaDR: [
      tipoCambioRule,
      'numeric',
      'decimal:10'
    ],
    MetodoDePagoDR: [
      'string',
      'in:PUE,PPD',
    ],
    NumParcialidad: [
      'required',
      'integer',
      'regex:/^[1-9][0-9]{0,2}$/',
    ],
    ImpSaldoAnt: [
      'required',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    ImpPagado: [
      'required',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    ImpSaldoInsoluto: [
      'required',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    ObjetoImpDR: ['required']
  }
};

export default ComplementoPagosDRRules;